import React, {useCallback, useEffect, useMemo} from "react";
import {useConfigureNotebook} from "../../../../../../hooks/use-notebook-config";
import {Tab, Tabs} from "../../../../../../components/base/Tabs";
import WarrantyAndReturnStatusesViewRequestStatusesSection from "./request-statuses";
import WarrantyAndReturnStatusesViewVendorStatusesSection from "./vendor-statuses";
import useQuery from "../../../../../../hooks/use-query";
import useBehavioralAnalyticsTool from "../../../../../../hooks/use-behavioural-analytics-tool";

const tabs = {
    requests: 'requests',
    vendors: 'vendors',
}

const WarrantyAndReturnStatusesView = () => {
    const [query, setQuery] = useQuery();
    const {configureNotebookTags} = useConfigureNotebook('warranty-and-return-status-settings-view');
    const {configureBehavioralTool} = useBehavioralAnalyticsTool();

    const tab = useMemo(() => query.tab ?? tabs.requests, [query.tab]);

    /**
     * As soon as the component is mounted:
     * - Configures the notebook tags for the view
     * - Configures the behavioral analytics tool for the view
     */
    useEffect(() => {
        configureNotebookTags((noteTags) => noteTags.warrantyAndReturnSettingsStatuses);
        configureBehavioralTool((tags) => tags.warrantyAndReturnSettingsStatuses);
    }, [configureBehavioralTool, configureNotebookTags]);

    /**
     * Sets the tab of the view
     * @type {(function(*, *): void)}
     */
    const setTab = useCallback((_, tab) => {
        setQuery({tab: tab,})
    }, [setQuery])

    return (
        <>
            <div className='w-100 flex-grow-1'>
                <Tabs value={tab} onChange={setTab}>
                    <Tab value={tabs.requests} label={"Manage Request Statuses"}/>
                    <Tab value={tabs.vendors} label={"Manage Vendor Statuses"}/>
                </Tabs>
            </div>
            <div className='my-4 w-100'/>
            {
                tab === tabs.requests &&
                <WarrantyAndReturnStatusesViewRequestStatusesSection/>
            }
            {
                tab === tabs.vendors &&
                <WarrantyAndReturnStatusesViewVendorStatusesSection/>
            }
        </>
    )
}


export default WarrantyAndReturnStatusesView;
